export default __webpack_public_path__ + "static/media/pepper.e1d2e820.png";